<template>
    <div class="agreement_box no-trans" v-loading="loading">
        <el-dialog :title="titles" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="form_box">
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                原告
                            </div>
                            <div class="fomr_input1">
                                文字23123
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                国籍
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <span>*</span>
                                当事人姓名
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                性别
                            </div>
                            <div class="fomr_input1">
                               
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件类型
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件号码
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                出生日期
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                民族
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                政治面貌
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                联系电话
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                电子邮箱
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                邮政编码
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            居住地址
                        </div>
                        <div class="fomr_input2">
                             
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            户籍地址
                        </div>
                        <div class="fomr_input2">
                             
                        </div>
                    </div>
                </div>
               
            </div>
        </el-dialog>

        <el-dialog :title="titles" :visible.sync="dialogVisible2" :close-on-click-modal="false"
            :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="form_box">
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                原告
                            </div>
                            <div class="fomr_input1">
                                文字23123
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                国家或地区
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <span>*</span>
                                单位名称
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                邮政编码
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件种类
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                证件号码
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                法定代表人
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                联系电话
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                代表人证件种类
                            </div>
                            <div class="fomr_input1">
                                
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                代表人证件号码
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                职务
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                        <div class="forms">
                            <div class="fomr_titles">
                                <!-- <span>*</span> -->
                                电子邮箱
                            </div>
                            <div class="fomr_input1">
                                 
                            </div>
                        </div>
                    </div>
                    <div class="forms">
                        <div class="fomr_titles">
                            <!-- <span>*</span> -->
                            机构所在地址
                        </div>
                        <div class="fomr_input2">
                             
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            titles: '新增原告',
            dialogVisible: false,//原告
            dialogVisible2: false,//被告
            

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.dialogVisible2 = false
        },
        handle_end() {
            this.dialogVisible = false
            let objs={
                type:1,
            }
            this.$emit('handle_end',objs)
        },
        handle_end2(){
            this.dialogVisible2 = false
            let objs={
                type:2
            }
            this.$emit('handle_end',objs)
        },
        handle_qx() {
            this.dialogVisible = false
            this.dialogVisible2 = false
        },
        handle_open(item,i) {
            console.log('1231',i)
            if (i == 1) {
                this.titles = '原告信息'
                this.dialogVisible = true
            }
            if (i == 2) {
                this.titles = '被告信息'
                this.dialogVisible2 = true

            }
            if (i == 3) {
                this.titles = '第三人信息'
                this.dialogVisible2 = true

            }
        }



    },

}
</script>
<style scoped lang="less">
.agreement_box {
    /deep/.el-dialog__wrapper {
        .el-dialog {
            width: 960px;

            .el-dialog__header {
                background: #F7F7F7;
            }

            .el-dialog__body {
                .dialog_box {
                    .form_box {
                        padding: 20px 20px;

                        .form_flex {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                        }

                        .forms {
                            display: flex;
                            align-items: center;
                            margin-bottom: 24px;

                            .fomr_titles {
                                width: 120px;
                                flex-shrink: 0;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;
                                padding-right: 15px;

                                span {
                                    color: #FD4C5C;
                                    margin-right: 5px;
                                }
                            }

                            .fomr_input1 {
                                padding: 0 14px;
                                width: 320px;
                                min-height: 40px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #B8C4D1;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                display: flex;
                                align-items: center;

                            }

                            .fomr_input2 {
                                width: 817px;
                                height: 40px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #B8C4D1;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                display: flex;
                                align-items: center;
                            }
                        }

                    }

                    .btn_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .bnts1 {
                            width: 104px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }

                        .bnts2 {
                            width: 104px;
                            height: 40px;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            margin-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .agreement_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box {
        padding: 16px 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        flex-direction: column;
        align-items: stretch;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_titles {
        width: 120px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-right: 15px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_titles span {
        margin-right: 5px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input1 {
        padding: 0 14px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .form_box .forms .fomr_input2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 40px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts1 {
        width: 104px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts2 {
        width: 104px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
        margin-left: 16px;
    }
}
</style>
